import { BookedPriceRevealSection } from "./components/BookedPriceRevealSection";

interface Props {
  shipment: CarrierCondensedShipment;
  dividerComponent: JSX.Element;
}

export function ShipmentDataSection(props: Props) {
  const { shipment, dividerComponent } = props;
  return (
    <BookedPriceRevealSection
      shipment={shipment}
      dividerComponent={dividerComponent}
    />
  );
}
